/**
 * Homepage glass: shared white frost (135°) for hero input + silo pills.
 */

export const HOME_GLASS_BORDER = "1px solid rgba(255, 255, 255, 0.1)";
export const HOME_GLASS_BACKDROP = "blur(28px) saturate(112%)";

const whiteGlassRest =
  "linear-gradient(135deg, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0.1))";
const whiteGlassHover =
  "linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.15))";

/** Wide hero input — same fill as silo default / hover */
export const homeGlassHero = {
  rest: whiteGlassRest,
  hover: whiteGlassHover,
};

/** Silo pills — same base + active rungs for route state */
export const homeGlassSilo = {
  rest: whiteGlassRest,
  hover: whiteGlassHover,
  active: "linear-gradient(135deg, rgba(255, 255, 255, 0.36), rgba(255, 255, 255, 0.2))",
  activeHover: "linear-gradient(135deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.24))",
};

/** Silo + hero: shared inset / drop (hero adds a bit of spread for the wide bar) */
const shadowWhiteRest =
  "inset 0 1px 0 rgba(255,255,255,0.24), 0 8px 16px rgba(0,0,0,0.15)";

export const HOME_GLASS_SHADOW_HERO = `${shadowWhiteRest}, 0 18px 40px rgba(0,0,0,0.12)`;

export const homeGlassShadow = {
  rest: shadowWhiteRest,
  active: "inset 0 1px 0 rgba(255,255,255,0.35), 0 10px 22px rgba(0,0,0,0.22)",
};
